import type { AddressSummaryAddress } from '@/components/checkout/AddressSummary';
import type { BillingAddressFormData } from '@/lib/checkout';
import type { ServiceAddress } from '@/lib/service/ecs/contracts';

/** Reverse of `mapStoredToServiceAddress` for editable address forms. */
export function mapServiceAddressToFormData(address: ServiceAddress): BillingAddressFormData {
  const summary = mapServiceAddressToSummary(address);

  return {
    firstName: summary.firstName,
    lastName: summary.lastName,
    companyName: summary.companyName ?? '',
    streetAddress1: summary.streetAddress1,
    streetAddress2: summary.streetAddress2 ?? '',
    city: summary.city,
    postalCode: summary.postalCode,
    countryArea: summary.countryArea ?? '',
    country: address.country,
    phone: '',
  };
}

/** Reverse of `mapStoredToServiceAddress` for read-only address summaries. */
export function mapServiceAddressToSummary(address: ServiceAddress): AddressSummaryAddress {
  if (address.address2) {
    return {
      firstName: address.firstName,
      lastName: address.lastName,
      companyName: address.address1 || undefined,
      streetAddress1: address.address2,
      streetAddress2: address.address3 || undefined,
      city: address.city,
      postalCode: address.zipCode,
      countryArea: address.state || undefined,
    };
  }

  return {
    firstName: address.firstName,
    lastName: address.lastName,
    streetAddress1: address.address1,
    streetAddress2: address.address3 || undefined,
    city: address.city,
    postalCode: address.zipCode,
    countryArea: address.state || undefined,
  };
}
